<template>
  <div class="legal-page">
    <header class="legal-header">
      <button type="button" class="legal-back" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </button>
      <h1>用户协议</h1>
    </header>
    <article class="legal-body">
      <p class="legal-meta">更新日期：2026 年 4 月 10 日 · 生效日期：2026 年 4 月 10 日</p>
      <p class="legal-lead">
        欢迎使用本服务。请您在注册、登录或使用前仔细阅读本协议。您点击同意或实际使用服务，即视为已阅读并接受本协议全部条款。
      </p>

      <section>
        <h2>一、协议的接受与修改</h2>
        <p>
          1.1 本协议由您与 Ez-Insight（下称「我们」）共同缔结，对双方具有约束力。<br>
          1.2 我们有权根据业务与法律要求修订本协议，修订后将通过站内提示或公告等方式告知。若您不同意修订内容，请停止使用服务；继续使用视为接受修订后的协议。
        </p>
      </section>

      <section>
        <h2>二、账号与使用规范</h2>
        <p>
          2.1 您应使用真实、准确的信息注册账号，并妥善保管账号与密码。因您保管不善导致的损失由您自行承担。<br>
          2.2 您不得将账号转让、出借或以其他方式提供给第三方使用，除非事先获得我们书面同意。<br>
          2.3 您不得利用本服务从事违法违规活动，包括但不限于：侵犯他人知识产权、传播违法信息、干扰系统正常运行、爬虫滥用等。
        </p>
      </section>

      <section>
        <h2>三、服务内容与变更</h2>
        <p>
          3.1 本服务包括但不限于文本/视频总结、内容管理等功能，具体以实际提供为准。<br>
          3.2 因维护、升级、不可抗力或合作方原因，我们可能对服务进行调整、中断或终止，并将尽可能事先公告。除法律另有规定外，我们不因此对您的间接或附带损失承担责任。
        </p>
      </section>

      <section>
        <h2>四、用户内容与知识产权</h2>
        <p>
          4.1 您上传、输入的内容（含链接、文本等）的知识产权归您或合法权利人所有。您授权我们在提供、改进服务所必需的范围内使用、存储与处理该等内容。<br>
          4.2 本服务界面、软件、文档等所涉知识产权归我们或权利人所有，未经许可您不得复制、修改、传播或用于商业目的。
        </p>
      </section>

      <section>
        <h2>五、免责声明与责任限制</h2>
        <p>
          5.1 本服务按「现状」提供，我们不对服务结果的准确性、完整性、适用性作明示或默示保证。<br>
          5.2 在法律允许的最大范围内，我们对因使用或无法使用本服务所产生的利润损失、数据丢失等间接损害不承担责任；我们的赔偿责任以您就争议服务已支付的费用为上限（若免费则以合理范围为限）。
        </p>
      </section>

      <section>
        <h2>六、法律适用与争议解决</h2>
        <p>
          6.1 本协议的订立、效力与解释适用中华人民共和国法律。<br>
          6.2 因本协议引起的争议，双方应协商解决；协商不成的，提交我们住所地有管辖权的人民法院诉讼解决。
        </p>
      </section>

      <section>
        <h2>七、联系我们</h2>
        <p>
          若您对本协议有疑问，可通过产品内提供的联系方式或管理员渠道与我们联系。本初版为占位说明，正式对外前请由法务审核并替换为最终文本。
        </p>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: 'UserAgreementPage',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/login')
      }
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #faf8f5;
  color: #0a1c44;
  padding: env(safe-area-inset-top, 0px) max(16px, env(safe-area-inset-right, 0px))
    env(safe-area-inset-bottom, 0px) max(16px, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
}

.legal-header {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0 16px;
  background: linear-gradient(180deg, #faf8f5 85%, transparent);
}

.legal-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: #4253ff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(10, 28, 68, 0.08);
}

.legal-header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.legal-body {
  max-width: 640px;
  margin: 0 auto;
  padding-bottom: 32px;
  font-size: 14px;
  line-height: 1.75;
  color: #3d4f6f;
}

.legal-meta {
  font-size: 12px;
  color: #8b95a8;
  margin: 0 0 16px;
}

.legal-lead {
  margin: 0 0 24px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(10, 28, 68, 0.06);
  color: #4f6188;
}

.legal-body section {
  margin-bottom: 22px;
}

.legal-body h2 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #0a1c44;
}

.legal-body p {
  margin: 0;
}
</style>
